import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const Droplet = React.memo(
  ({ width = 62, fill = variables['colors-mc-logo-2'], viewBox = '0 0 62 62' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <path
        d='M48.2319 0H13.522C6.06198 0 0.00195694 6.06 0.00195694 13.52V48.23C0.00195694 55.69 6.06198 61.75 13.522 61.75H48.2319C55.6919 61.75 61.752 55.69 61.752 48.23V13.52C61.752 6.06 55.6919 0 48.2319 0Z'
        fill={fill}
      />
      <path
        d='M30.8733 13.2803C30.8733 13.2803 43.4434 24.6903 43.4434 38.1303C43.4434 45.0703 37.8133 50.7003 30.8733 50.7003C23.9333 50.7003 18.3033 45.0703 18.3033 38.1303C18.3033 24.7003 30.8733 13.2803 30.8733 13.2803Z'
        fill='white'
      />
    </svg>
  )
);
Droplet.displayName = 'Droplet';

export default Droplet;
